import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Input, Alert } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import FormSubmitButton from '../FormSubmitButton'

export default function LogReportForm({ location }) {
  console.log('LogReportForm rendered: ', location)

  let init = {
    date: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('LogReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState()

  async function submitSearch() {
    console.log('LogReportForm.submitSearch', inputs)

    let validInput = true
    if (!inputs.date) {
      validInput = false
    }
    if (!validInput) {
      return setFormFeedback(<tr><td colSpan={2}><Alert className='custom-alert' color='danger' style={{display: 'block', textAlign: 'center', margin: 'auto'}}>Must have a date selected</Alert></td></tr>)
    }

    const params = new URLSearchParams(location.search)
    const type = params.get('in_type')
    inputs.type = type
    submitFormValues('LogReportForm', navigate, inputs, 'logs.log_report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            {formFeedback}
            <tbody>
              <tr>
                <td style={{verticalAlign: 'middle'}} ><b>Reconciliation Date</b></td>
                <td>
                  <Input className="custom-input" type='date' name='date' onChange={handleInputChange} defaultValue={inputs.date} />
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Run Report' />
      </form>
    </div>
  )
}

